import classNames from 'classnames'
import React, { useContext, useEffect } from 'react'
import { ChatContext } from '~/service/chatConn'
import {
  NavLink,
  Redirect,
  Route,
  Switch,
  useRouteMatch,
} from 'react-router-dom'
import List from './List'
import Show from './Show'
import { FormattedMessage } from '~/translations/utils'
import { InternalChatManagerContext } from '~/service/InternalChatManager'
import useResizeObserver from 'use-resize-observer'

const InternalChat: React.FC = ({}) => {
  const { path } = useRouteMatch()
  const chatShow = useRouteMatch('/internal-chat/:chatId')
  const chatList = useRouteMatch('/internal-chat')

  return (
    <Switch>
      <Route path={path + '/'}>
        <div
          className={classNames('chat chat-history', {
            'is-any-active': chatShow,
          })}
        >
          <List />
          <Route path={path + '/:chatId'}>
            <div className="chat-activeChat">
              <Show />
            </div>
          </Route>
          {!chatShow && (
            <div className="chat-empty">
              <span className="fat fa-messages" />
            </div>
          )}
        </div>
      </Route>
    </Switch>
  )
}

export default InternalChat
